import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server, { uploadServer } from "../../api/server";
import { v4 } from "uuid";
import ReactQuill from "react-quill";

import { Controller } from "react-hook-form";
import { toast } from "react-toastify";

const AboutUsShow = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [currentInfo, setCurrentInfo] = useState({});
	const dispatch = useDispatch();

	const {
		params: { aboutUsSectionId },
	} = match;

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		getValues,
		control,
		reset,
	} = useForm();
	const { append, remove, fields } = useFieldArray({
		name: "extraInfo",
		control,
	});
	const [pictureImg, setPictureImg] = useState(userPlaceholder);
	const quillModules = {
		toolbar: [
			[{ header: [1, 2, false] }],
			["bold", "italic", "underline", "strike"],
			[{ align: [] }],
			[{ list: "ordered" }, { list: "bullet" }],
			["blockquote", "code-block"],
			["link", "image", "video"],
			["clean"],
		],
	};

	const quillFormats = [
		"header",
		"bold",
		"italic",
		"underline",
		"strike",
		"align",
		"list",
		"blockquote",
		"code-block",
		"direction",
		"link",
		"image",
		"video",
	];
	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "اضافة فئة جديدة",
				breadcrumb: "الفئات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		try {
			const initialData = await server(cookie).get(
				`/pages/about-us/sections/about-us`
			);
			setPictureImg(
				`${process.env.REACT_APP_MAIN_URL}/${initialData?.data?.data?.section?.image}`
			);
			setValue("subTitle", initialData?.data?.data?.section?.subTitle);
			setValue("extraInfo", initialData?.data?.data?.section?.extraInfo);
			setValue("vision", initialData?.data?.data?.section?.vision);
			setValue("message", initialData?.data?.data?.section?.message);
			setValue("services", initialData?.data?.data?.section?.services);
			setValue("features", initialData?.data?.data?.section?.features);
			setValue("picturePath", initialData?.data?.data?.section?.image);
			setValue("aboutUs", initialData?.data?.data?.section?.aboutUs);
		} catch (error) {
			console.log(error);
		}
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const imageResponse = async () => {
				if (data.pictureUrl.length <= 0) return data.picturePath;
				const dataForm = new FormData();
				dataForm.append("file", data.pictureUrl[0]);
				const imageData = await uploadServer(cookie).post("/upload", dataForm);
				return imageData?.data?.data?.file?.path;
			};
			const imageData = await imageResponse();

			const { picturePath, pictureUrl, ...finalData } = {
				...data,
				title: "about us",
				image: imageData,
			};

			const dataResponse = await server(cookie).put(
				`/pages/about-us/sections/about-us`,
				{
					section: finalData,
				}
			);
			toast.success("تم تعديل البيانات بنجاح");
			reset();
			onStart();
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const handlePicture = () => {
		const tempValue = getValues("pictureUrl");
		if (tempValue.length < 1) return;
		const blobUrl = URL?.createObjectURL(tempValue?.[0]);
		setValue("picturePath", blobUrl);
		setPictureImg(blobUrl);
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);

	console.log(errors);

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-8">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleAr">العنوان باللغة العربية</label>
									<input
										type="text"
										name="titleAr"
										id="titleAr"
										{...register("subTitle.ar")}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleEn">العنوان بالغة الانجليزية</label>
									<input
										type="text"
										name="titleEn"
										id="titleEn"
										{...register("subTitle.en")}
									/>
								</div>
							</div>



							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleAr">الروئية باللغة العربية</label>
									<input
										type="text"
										name="titleAr"
										id="titleAr"
										{...register("vision.title.ar")}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleEn">الروئية بالغة الانجليزية</label>
									<input
										type="text"
										name="titleEn"
										id="titleEn"
										{...register("vision.title.en")}
									/>
								</div>
							</div>

							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionAr">
										وصف الرؤية باللغة العربية
									</label>
									<Controller
										name="vision.description.ar"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												theme="snow"
												id="descriptionAr"
												placeholder="أدخل وصف الرؤية..."
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
								</div>
							</div>

							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionEn">
										وصف الرؤية باللغة الإنجليزية
									</label>
									<Controller
										name="vision.description.en"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												theme="snow"
												id="descriptionEn"
												placeholder="Enter vision description..."
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
								</div>
							</div>











							<div className="row mb-3">
								{/* Arabic About Company */}
								<div className="col-xs-12 col-md-12 mb-5">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="descriptionAr">
												سيرة الشركة باللغة العربية
											</label>
											<Controller
										name="aboutUs.description.ar"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												theme="snow"
												id="descriptionEn"
												// placeholder="Enter about description..."
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
										</div>
									</div>
								</div>

								{/* English About Company */}
								<div className="col-xs-12 col-md-12 mb-5">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="descriptionEn">
												سيرة الشركة باللغة الإنجليزية
											</label>
											<Controller
										name="aboutUs.description.en"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												theme="snow"
												id="descriptionEn"
												// placeholder="Enter vision description..."
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
										</div>
									</div>
								</div>
							</div>






							<div className="card-body">
								<div className="form-item">
									<label htmlFor="subTitleAr">الرسالة باللغة العربية</label>
									<input
										type="text"
										name="subTitleAr"
										id="subTitleAr"
										{...register("message.title.ar")}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="subTitleEn">الرسالة بالغة الانجليزية</label>
									<input
										type="text"
										name="subTitleEn"
										id="subTitleEn"
										{...register("message.title.en")}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="messageDescriptionAr">
										وصف الرسالة باللغة العربية
									</label>
									<Controller
										name="message.description.ar"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												id="messageDescriptionAr"
												theme="snow"
												placeholder="أدخل وصف الرسالة..."
												dir="rtl"
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
								</div>
							</div>

							{/* وصف الرسالة باللغة الإنجليزية */}
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="messageDescriptionEn">
										وصف الرسالة باللغة الإنجليزية
									</label>
									<Controller
										name="message.description.en"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												id="messageDescriptionEn"
												theme="snow"
												placeholder="Enter message description..."
												dir="ltr"
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
								</div>
							</div>

							{/* المميزات باللغة العربية */}
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleAr">المميزات باللغة العربية</label>
									<input
										type="text"
										name="titleAr"
										id="titleAr"
										{...register("features.title.ar")}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleEn">المميزات بالغة الانجليزية</label>
									<input
										type="text"
										name="titleEn"
										id="titleEn"
										{...register("features.title.en")}
									/>
								</div>
							</div>

							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionAr">
										وصف المميزات باللغة العربية
									</label>
									<Controller
										name="features.description.ar"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												theme="snow"
												id="descriptionAr"
												placeholder="أدخل وصف المميزات..."
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
								</div>
							</div>

							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionEn">
										وصف المميزات باللغة الإنجليزية
									</label>
									<Controller
										name="features.description.en"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												theme="snow"
												id="descriptionEn"
												placeholder="Enter features description..."
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
								</div>
							</div>

							{/* services */}
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleAr">الخدمات باللغة العربية</label>
									<input
										type="text"
										name="titleAr"
										id="titleAr"
										{...register("services.title.ar")}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleEn">الخدمات بالغة الانجليزية</label>
									<input
										type="text"
										name="titleEn"
										id="titleEn"
										{...register("services.title.en")}
									/>
								</div>
							</div>

							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionAr">
										وصف الخدمات باللغة العربية
									</label>
									<Controller
										name="services.description.ar"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												theme="snow"
												id="descriptionAr"
												placeholder="أدخل وصف الخدمة..."
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
								</div>
							</div>

							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionEn">
										وصف الخدمات باللغة الإنجليزية
									</label>
									<Controller
										name="services.description.en"
										control={control}
										// rules={{ required: true }}
										render={({ field }) => (
											<ReactQuill
												{...field}
												theme="snow"
												id="descriptionEn"
												placeholder="Enter services description..."
												modules={quillModules}
												formats={quillFormats}
											/>
										)}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">البانر</label>
									<input
										type="file"
										id="picture"
										{...register("pictureUrl", {
											onChange: () => handlePicture(),
										})}
									/>
									<img src={pictureImg} alt="avatar" className="imagePreview" />
								</div>
							</div>
							<div className="card-body">
								<div className="row">
									<div className="col-md-12">
										<div className="form-item">
											<label htmlFor="infoTitle.ar">
												العنوان بالغة العربية
											</label>
											<input
												type="text"
												name="infoTitle.ar"
												id="infoTitle.ar"
												onChange={e =>
													setCurrentInfo({
														...currentInfo,
														name: { ...currentInfo.name, ar: e.target.value },
													})
												}
											/>
										</div>
										<div className="form-item">
											<label htmlFor="infoTitle.en">
												العنوان بالغة الانجليزية
											</label>
											<input
												type="text"
												name="infoTitle.en"
												id="infoTitle.en"
												onChange={e =>
													setCurrentInfo({
														...currentInfo,
														name: { ...currentInfo.name, en: e.target.value },
													})
												}
											/>
										</div>
										<div className="form-item">
											<label htmlFor="count">الكمية</label>
											<input
												type="number"
												name="count"
												id="count"
												min={0}
												onChange={e =>
													setCurrentInfo({
														...currentInfo,
														count: e.target.value,
													})
												}
											/>
										</div>
										<div className="form-item">
											<p
												className="bt bt-success btn-block"
												onClick={() =>
													fields.length > 1 ? null : append({ ...currentInfo })
												}
												style={{ textAlign: "center", cursor: "pointer" }}
											>
												اضف المعلومة
											</p>
										</div>
									</div>
									{fields.map((field, index) => (
										<div className="col-md-12" key={v4()}>
											انجاز {index + 1}
											<p>
												{field?.name.ar} <span>{field?.count}</span>
											</p>
											<i
												className="fas fa-trash"
												onClick={() => remove(index)}
											/>
										</div>
									))}
								</div>
							</div>
						</div>
						<input
							type="text"
							name=""
							id=""
							style={{ display: "none" }}
							{...register("picturePath")}
						/>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default AboutUsShow;
